import { Editor, type IAllProps } from '@tinymce/tinymce-react';
import type { Ref } from 'react';

export const RichText = (props: IAllProps & { ref?: Ref<Editor> }) => {
  return (
    <Editor
      ref={props.ref}
      tinymceScriptSrc="/tinymce6/tinymce.min.js"
      {...props}
      init={{ language: 'zh-Hans', ...props.init }}
    ></Editor>
  );
};
